import React from 'react';
import { usePlanStepIds } from '@/contexts/FlowAgentContext';

export const PlanStepIdInput = ({ value, onChange }) => {
  const planStepIds = usePlanStepIds();

  return (
    <select value={value} onChange={onChange}>
      <option value={''}>Please select...</option>
      {planStepIds.map((id) => (
        <option key={id} value={id}>
          {id}
        </option>
      ))}
    </select>
  );
};
